<div class="content-height d-lg-block d-none">
    <div class="row h-100">
        <div class="col-6 image-section position-relative">
            <div class="mt-2">
                <div class="d-flex justify-content-between flex-column align-items-center">
                    <apnst-material-stepper [steps]="steps" class="mb-6"></apnst-material-stepper>
                    <img class="img img-fluid " src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718110844207Frame%201000002351%20%282%29.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-primary-faint mb-3">
                        <div class="col-1 faq-primary-div-height">
                            <h6 class="rotate-text text-center mt-5 py-2">FAQ</h6>
                        </div>
                        <div class="col-11">
                            <div class="d-flex justify-content-between align-items-center">
                                <img class="img img-fluid" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718111111101Marks%201%20%281%29.png" alt="">
                                <h6 class="me-2">How do I calculate how much Loan Amount I require?</h6>
                                <button (click)="openModalCalculateLoan()" class="btn btn-primary-gradient px-3">Check
                                    how?</button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-6 overflow-hidden">
            <div class="" *ngIf="loanService?.studentDetails?.countryCode === '+91' || ((loanService?.studentDetails?.universityVendors)?.includes('prodigy') || (loanService?.studentDetails?.universityVendors)?.includes('mpower'))">
                <apnst-common-header [configHeader]="configLoanAmountHeader" [showHeaderWeb]="true" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
            </div>
            <div class="container h-100 overflow-hidden">
                <div *ngIf="showLoanAmountInput" class="mb-4">
                    <p class="text-gray mb-0">Enter the loan amount required</p>
                    <div class="row align-items-center">
                        <div class="col-3">
                            <aerp-base-schema-form class="" *ngIf="model && layout" [model]="model" [layout]="layout"></aerp-base-schema-form>
                        </div>

                        <div class="width-currency col-9">
                            <input [value]="commaLoanAmount??''" id="loanAmountInput" (keyup)="inrLoanAmount($event)" required [(ngModel)]="modelName" #hash=ngModel type="text" class="form-control rounded-1 mt-n3 width-currency" placeholder="Enter Loan Amount" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                            />
                        </div>

                        <p *ngIf="!showNumberToWords" #loanAmountErrorMobile class="fs-8 fw-light text-danger">We can arrange funds from ₹7 lakhs to ₹3 crore inclusive of Tuition fees & Living expenses</p>

                        <p *ngIf="showNumberToWords  && showNumberToWords!=='NaN'" class="text-primary mt-n2"> {{showNumberToWords|titlecase}} {{model?.loanAmountCurrency}}</p>
                    </div>
                    <div *ngIf="showLoanType" class="loanSelection mt-2 mb-3 custom-height-loan">
                        <hr class="mb-5">
                        <h4>Choose loan type</h4>
                        <div class="accordion accordion-flush" id="accordionFlushExample">
                            <div class="accordion-item mb-3" *ngIf="loanService?.studentDetails?.countryCode === '+91'">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                        <span>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <img class="img img-fluid me-2"
                                                        src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715679364091Icon.png"
                                                        alt="">
                                                </div>
                                                <div class="mt-3">
                                                    <p class="text-gray mb-0 fs-8">SECURED/COLLATERAL LOAN</p>
                                                    <p>Loan with property</p>
                                                </div>
                                            </div>

                                        </span>
                                    </button>
                                </h2>
                                <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                    <div class="accordion-body mb-3">
                                        <ol class="text-muted">
                                            <li class="mb-2">Collaterals like property or fixed deposit required</li>
                                            <li class="mb-2">Lower interest rates, starting at 9%</li>
                                            <li class="mb-2">Higher chances of approval</li>
                                            <li>Higher loan amount and longer repayment</li>
                                        </ol>
                                    </div>

                                    <button class="btn btn-primary w-100 custom-btn-class" (click)="typeOfLoan('Secured Loan(with Property)')">Choose</button>
                                </div>
                            </div>

                            <div class="accordion-item mb-3" *ngIf="loanService?.studentDetails?.countryCode === '+91'">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                        <span>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <img class="img img-fluid me-2"
                                                        src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715683625186profile-2user.png"
                                                        alt="">
                                                </div>
                                                <div class="mt-3">
                                                    <p class="text-gray mb-0 fs-8">UNSECURED/CO-APPLICANT LOAN</p>
                                                    <p>Loan with Co-applicant</p>
                                                </div>
                                            </div>

                                        </span>
                                    </button>
                                </h2>
                                <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                    <div class="accordion-body mb-3">
                                        <ol class="text-muted">
                                            <li class="mb-2">No Collateral needed</li>
                                            <li class="mb-2">Rate of interest starts from 9.75%</li>
                                            <li class="mb-2">Income co-applicant is mandatory.</li>
                                            <li>Loan processed in 5-7 working days*</li>
                                        </ol>
                                    </div>
                                    <button class="btn btn-primary w-100 custom-btn-class" (click)="typeOfLoan('Unsecured Loan(without Property)')">Choose</button>
                                </div>
                            </div>
                            <div class="accordion-item" *ngIf="loanService?.studentDetails?.targetDegree != 'Bachelors' && ((loanService?.studentDetails?.universityVendors)?.includes('prodigy')||(loanService?.studentDetails?.universityVendors)?.includes('mpower'))">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                        <span>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <img class="img img-fluid me-2"
                                                        src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715683675809dollar-square.png"
                                                        alt="">
                                                </div>
                                                <div class="mt-3">
                                                    <p class="text-gray mb-0 fs-8">INTERNATIONAL LOAN</p>
                                                    <p>No-cosigner loan</p>
                                                </div>
                                            </div>

                                        </span>
                                    </button>
                                </h2>
                                <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                    <div class="accordion-body mb-3">
                                        <ol class="text-muted">
                                            <li class="mb-2">No Collateral & No Co-signer needed</li>
                                            <li class="mb-2">Rate of interest starts from 11.75%</li>
                                            <li class="mb-2">Only for Master’s or MBA courses at listed universities.
                                            </li>
                                            <li>Get loan up to $100,000</li>
                                        </ol>
                                    </div>
                                    <button class="btn btn-primary w-100 custom-btn-class" (click)="typeOfLoan('International Loan(Non Collateral-Cosigner)')">Choose</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="loanService?.studentDetails?.countryCode !== '+91' && !((loanService?.studentDetails?.universityVendors)?.includes('prodigy')||(loanService?.studentDetails?.universityVendors)?.includes('mpower'))">

                    <div class="mx-2">
                        <div class="d-flex justify-content-end pt-3">
                            <span class="logout p-2" (click)="logout()"><img src="../../../../assets/logo/logout.svg"
                                    class="img img-fluid  me-1 text-dark"> Logout</span>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-center mb-3 mt-10">
                            <img src="../../../../assets/logo/nosuggested.svg" class="img img-fluid mb-3" width="200" height="200">
                            <div class="text-center">
                                <h5 class="text-warning fw-bold fs-4">No Loan Type Suggested</h5>
                                <p class="text-dark w-75 mx-auto fs-6 fw-bold">
                                    We couldn’t suggest any offers based on your details.
                                </p>
                            </div>
                            <p class="text-muted mx-auto">Please raise a request for support from our team.</p>
                            <button type="button" class="btn btn-primary text-white fw-bold rounded-custom  custom-btn-class mx-auto w-50" (click)="raiseARequest()">Connect to Counsellor
                            </button>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>


    <ng-template #calculateLoan let-modal>
        <div class="modal-header">
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.close('Close click')"></button>
        </div>

        <div class="modal-body fw-dark">
            <div class="px-2">
                <h4 class="mb-2">How to calculate required Loan Amount?</h4>
                <div class="bg-modal px-2 py-1 mb-2">
                    <p class="text-gray mb-1">The Formula for calculating loan amount is - </p>
                    <p class="fw-bold">Loan Amount = <span class="text-primary">(Cost of Education + Living expenses +
                            Travel expenses + Health Insurance + Other miscellaneous exp)</span> - <span class="text-primary-dark">(Scholarship amount + Personal funding)</span></p>
                </div>

                <div class="loan-calc-modal">
                    <p class="mb-1">Here’s an Example -</p>
                    <p>Let’s say that you are going for a 2 years Masters Program. This is how the calculation would look like -</p>
                    <img class="img img-fluid mb-2" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718286346800Table.png" alt="">
                    <p class="mb-1">So, after applying the formula to the above expenses, it calculation will be -</p>
                    <p>Loan Amount = $(40,000 + 24,000 + 2000 + 2400 + 2000) - $(5000+10,000) = <span class="fw-bold">$49,400</span></p>
                    <hr class="text-primary">
                    <h4 class="text-primary-dark">Which is ~INR 41,00,000<span class="text-muted"> (1 USD = INR 83) </span></h4>
                </div>

            </div>
        </div>
        <div class="modal-footer px-4">
            <a class="btn btn-primary w-100 text-light" (click)="modal.close('Close click');">Thank
                you!</a>
        </div>
    </ng-template>

</div>

<div class="d-lg-none d-block">
    <div class="container">
        <div *ngIf="showLoanAmountInput" class="mb-4 header mt-4">
            <div class="mt-5">
                <apnst-material-stepper [steps]="steps"></apnst-material-stepper>
            </div>
            <div class="">
                <apnst-common-header [configHeader]="configLoanAmountHeader" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
            </div>
            <div class="row d-flex justify-content-center align-items-center">
                <p class="text-gray mb-0 ms-3">Enter the loan amount required</p>
                <div class="col-4">
                    <aerp-base-schema-form class="" *ngIf="model && layout" [model]="model" [layout]="layout"></aerp-base-schema-form>
                </div>

                <div class="width-currency col-8">
                    <input [value]="commaLoanAmount??''" id="loanAmountInput" (keyup)="inrLoanAmount($event)" required [(ngModel)]="modelName" #hash=ngModel type="text" class="form-control rounded-1 mt-n3 width-currency" placeholder="Enter Loan Amount" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                    />
                </div>

                <p *ngIf="!showNumberToWords" #loanAmountErrorMobile class="fs-8 fw-light text-danger ms-3">We can only arrange funds from 7lakhs to 3cr inclusive of Tuition fees & Living expenses</p>

                <p *ngIf="showNumberToWords  && showNumberToWords!=='NaN'" class="text-primary ms-3 mt-n2">{{showNumberToWords|titlecase}} {{model?.loanAmountCurrency}}</p>


                <div *ngIf="showLoanType" class="loanSelection mt-2 mb-3 ">
                    <hr class="mb-5">
                    <h4>Choose loan type</h4>
                    <div class="accordion accordion-flush overflow-y-auto" id="accordionFlushExample">
                        <div class="accordion-item mb-3" *ngIf="loanService?.studentDetails?.countryCode === '+91'">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                    <span>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <img class="img img-fluid me-2"
                                                    src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715679364091Icon.png"
                                                    alt="">
                                            </div>
                                            <div class="mt-3">
                                                <p class="text-gray mb-0 fs-8">SECURED/COLLATERAL LOAN</p>
                                                <p>Loan with property</p>
                                            </div>
                                        </div>

                                    </span>
                                </button>
                            </h2>
                            <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body mb-3">
                                    <ol class="text-muted">
                                        <li class="mb-2">Collaterals like property or fixed deposit required</li>
                                        <li class="mb-2">Lower interest rates, starting at 9%</li>
                                        <li class="mb-2">Higher chances of approval</li>
                                        <li>Higher loan amount and longer repayment</li>
                                    </ol>
                                </div>

                                <button class="btn btn-primary w-100 custom-btn-class" (click)="typeOfLoan('Secured Loan(with Property)')">Choose</button>
                            </div>
                        </div>

                        <div class="accordion-item mb-3" *ngIf="loanService?.studentDetails?.countryCode === '+91'">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                    <span>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <img class="img img-fluid me-2"
                                                    src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715683625186profile-2user.png"
                                                    alt="">
                                            </div>
                                            <div class="mt-3">
                                                <p class="text-gray mb-0 fs-8">UNSECURED/CO-APPLICANT LOAN</p>
                                                <p>Loan with Co-applicant</p>
                                            </div>
                                        </div>

                                    </span>
                                </button>
                            </h2>
                            <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body mb-3">
                                    <ol class="text-muted">
                                        <li class="mb-2">No Collateral needed</li>
                                        <li class="mb-2">Rate of interest starts from 9.75%</li>
                                        <li class="mb-2">Income co-applicant is mandatory.</li>
                                        <li>Loan processed in 5-7 working days*</li>
                                    </ol>
                                </div>
                                <button class="btn btn-primary w-100 custom-btn-class" (click)="typeOfLoan('Unsecured Loan(without Property)')">Choose</button>
                            </div>
                        </div>

                        <div class="accordion-item" *ngIf="loanService?.studentDetails?.targetDegree != 'Bachelors' && ((loanService?.studentDetails?.universityVendors)?.includes('prodigy')||(loanService?.studentDetails?.universityVendors)?.includes('mpower'))">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                    <span>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <img class="img img-fluid me-2"
                                                    src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715683675809dollar-square.png"
                                                    alt="">
                                            </div>
                                            <div class="mt-3">
                                                <p class="text-gray mb-0 fs-8">INTERNATIONAL LOAN</p>
                                                <p>No-cosigner loan</p>
                                            </div>
                                        </div>

                                    </span>
                                </button>
                            </h2>
                            <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body mb-3">
                                    <ol class="text-muted">
                                        <li class="mb-2">No Collateral & No Co-signer needed</li>
                                        <li class="mb-2">Rate of interest starts from 11.75%</li>
                                        <li class="mb-2">Only for Master’s or MBA courses at listed universities.</li>
                                        <li>Get loan up to $100,000</li>
                                    </ol>
                                </div>
                                <button class="btn btn-primary w-100 custom-btn-class" (click)="typeOfLoan('International Loan(Non Collateral-Cosigner)')">Choose</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="loanService?.studentDetails?.countryCode !== '+91' && !((loanService?.studentDetails?.universityVendors)?.includes('prodigy')||(loanService?.studentDetails?.universityVendors)?.includes('mpower'))">
        <div class="mb-8 overflow-hidden">
            <apnst-common-header [config]="config"></apnst-common-header>
        </div>
        <div class="mx-2">
            <div class="d-flex flex-column align-items-center justify-content-center mb-3 mt-10">
                <img src="../../../../assets/logo/nosuggested.svg" class="img img-fluid mb-3" width="150" height="150">
                <div class="text-center">
                    <h5 class="text-warning fw-bold">No Loan Type Suggested</h5>
                    <p class="text-black w-75 mx-auto">
                        We couldn’t suggest any offers based on your details.
                    </p>
                </div>
                <p class="text-muted">Please raise a request for support from our team.</p>
                <button type="button" class="btn btn-primary text-white fw-bold rounded-custom w-100 p-2" (click)="raiseARequest()">Connect to Counsellor
                </button>
            </div>

        </div>
    </div>
</div>

<ng-template #openErrorPopup let-modal>
    <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center flex-column">
            <img class="mb-4" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1699001972962Frame%201000001985.png" alt="errorTriangle">
            <h3 class="text-center mb-4">Please fill out all the required fields or check errors in form</h3>
            <button (click)="goBack()" class="btn btn-primary-goback text-light px-6 rounded-1 fw-bold">Go Back</button>
        </div>
    </div>
</ng-template>

<ng-template #content let-modal>
    <div class="modal-body">
        <div class="px-5">
            <div class="text-center text-primary-dark mb-6 py-4">
                <h4 class="mb-2">Your request has been send successfully. Our team will get back to you in 2 3 working days
                </h4>
                <p class="text-muted">Thanks for co-operating with us </p>
            </div>
            <div class="d-flex justify-content-center align-items-center mt-n6">
                <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1677050781144woman%20in%20online%20meeting%20with%20graphic%20tablet.png" alt="Thank you" class="img img-fluid">
            </div>
        </div>
    </div>
    <div class="modal-footer px-4">
        <a class="btn btn-primary w-100 text-light" (click)="modal.close('Close click'); logout()">Thank
            you!</a>
    </div>
</ng-template>